<template>
  <div class="main-wrap order">
    <div class="order-top">
      <div class="search-btns">
        <el-form :inline="true">
          <el-form-item v-if="exportStatus === 'wait_print'"></el-form-item>
          <el-form-item v-if="exportStatus === 'already_print' || exportStatus === 'wait_print'">
            <print ref="printOrder" :typeName="'oneAndtwoLinkPage'" :getPrintData="getPrintData" :options="printOptions" :hasPower="true" :isDisabled="printDisabled"></print>
          </el-form-item>
          <el-form-item v-if="exportStatus === 'already_print' || exportStatus === 'wait_print'">
            <el-button type="primary" class="h40" @click="batchCancelOrder" :disabled="multipleSelection.length > 0 ? false : true" icon="iconfont iconshanchu">{{
                $lang('批量取消')
              }}
            </el-button>
          </el-form-item>
          <el-form-item v-if="exportStatus === 'already_cancle'">
            <el-button type="primary" class="h40" @click="batchDelOrder" :disabled="multipleSelection.length > 0 ? false : true" icon="iconfont iconshanchu">{{
                $lang('批量删除')
              }}
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="iconfont icondaochu" type="primary" @click="exportOpen" :loading="exportLoading" class="h40" plain>{{ $lang('导出') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="iconfont icondaochu" type="primary" @click="dialogExportDownVisible = true" class="h40" plain>{{ $lang('下载中心') }}</el-button>
          </el-form-item>
<!--          <el-form-item>-->
<!--            <el-button icon="iconfont icondaochu" type="primary" @click="DhlOutput" class="h40" plain :loading="dhlLoading" :disabled="dhlDisabled">{{ $lang('导出DHL下单数据') }}</el-button>-->
<!--          </el-form-item>-->
        </el-form>
      </div>
      <div class="order-topLeft" id="jmsSearch">
        <el-form :model="searchParam" ref="seach" :inline="true">
          <el-form-item prop="date">
            <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="daterange"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始时间')"
              :end-placeholder="$lang('结束时间')"
              class="commonSize"
              @change="selectDate"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="ids">
            <base-input-tag
              style="width: 220px"
              v-model="searchParam.ids"
              :placeholder="$lang('请输入订单编号(最多可查100条)')"
              :clearBtnVisible="true"
              :addTagOnBlur="true"
              ref="BaseInputTag1"
              class="cms-input-tag"
            >
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="waybillIds">
            <base-input-tag
              style="width: 210px"
              v-model="searchParam.waybillIds"
              :placeholder="$lang('请输入运单编号(最多可查100条)')"
              :clearBtnVisible="true"
              ref="BaseInputTag2"
              :addTagOnBlur="true"
              class="cms-input-tag"
            >
            </base-input-tag>
          </el-form-item>
          <el-form-item prop="receiverMobilePhone">
            <el-input v-model="searchParam.receiverMobilePhone" :placeholder="$lang('请输入收件人联系电话')" maxlength="15"></el-input>
          </el-form-item>
          <el-form-item prop="customerOrderId">
            <el-input v-model="searchParam.customerOrderIds[0]" :placeholder="$lang('客户订单号')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('寄件国家')">
            <el-select clearable v-model="searchParam.senderCountryCode" :placeholder="$t('寄件国家')">
              <el-option v-for="item in countryList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('收件国家')">
            <el-select clearable v-model="searchParam.receiverCountryCode" :placeholder="$t('收件国家')">
              <el-option v-for="item in countryList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchChange" icon="iconfont iconchaxun" class="h32">{{ $lang('查询') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="resetSearch" icon="iconfont iconshanchu" class="h32">{{ $lang('清空') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-select clearable v-model="searchParam.serviceTypeCode" :placeholder="$t('请选择国际件类型')">
              <el-option v-for="item in serviceTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="order-bottom">
      <div class="tabs-nav">
        <div class="tabs-nav-item" v-for="(item, index) in menuItems" :key="index" @click="changeTab(index)" :class="{ active: tabActive === index }">
          {{ item.orderStatusName }}<span class="tabs-nav-item-count">{{ item.total }}</span>
        </div>
      </div>
      <JmsTableScroll
        ref="table"
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @size-change="sizeChange"
        :isCheckedAll="isCheckedAll"
        @select-all="handleSelectAll1"
        @select="handleSelectionChange"
        @current-change="currentChange"
      >
        <template slot="orderStatusName" slot-scope="data">
          <span class="dot" :class="data.row.orderStatusName == '待打印' ? 'oragin' : ''" v-show="data.row.orderStatusName == '待打印'">{{ $lang(data.row.orderStatusName) }}</span>
          <span class="dot" :class="data.row.orderStatusName == '已打印' ? 'oragin' : ''" v-show="data.row.orderStatusName == '已打印'">{{ $lang(data.row.orderStatusName) }}</span>
          <span class="dot" :class="data.row.orderStatusName == '已取件' ? 'green' : ''" v-show="data.row.orderStatusName == '已取件'">{{ $lang(data.row.orderStatusName) }}</span>
          <span class="dot" v-show="data.row.orderStatusName == '已取消'">{{ data.row.orderStatusName }}</span>
        </template>
        <template slot="waybillId" slot-scope="data">
          <el-tooltip placement="top">
            <div slot="content" @click="handleCopy(data)" style="cursor: pointer">{{ $lang('复制运单号') }}</div>
            <span @click="getExpressTracking(data.row.waybillId)" class="getExpressTracking">{{ data.row.waybillId }}</span>
          </el-tooltip>
        </template>
        <template slot="senderName" slot-scope="data">
          <div v-if="countryId === 1 && data.row.senderCountryName === 'KSA'" >
            <span>{{ `${data.row.senderName}/` }}</span>
            <span v-mask="{data: {...data.row,apiType:1},  key: 'senderMobilePhone', type: 'orderPlaintext' }" ></span>
            <span>{{ `/${data.row.senderProvinceName}/` }}</span>
            <span>{{ `/${data.row.senderCityName}` }}</span>
            <span>{{ data.row.senderAreaName ? '/' + data.row.senderAreaName : '' }}</span>
            <span>{{ data.row.senderStreet !== null && data.row.senderStreet !== null ? (data.row.senderStreet + '/') : '' }}</span>
            <span>{{ `${data.row.senderDetailedAddress || ''} ` }}</span>
          </div>
          <div v-else>
            <span>{{ `${data.row.senderName}/` }}</span>
            <span v-mask="{data: {...data.row,apiType:1},  key: 'senderMobilePhone', type: 'orderPlaintext' }" ></span>
            <span>{{ `/${data.row.senderProvinceName}` }}</span>
            <span>{{ `/${data.row.senderCityName}` }}</span>
            <span>{{ data.row.senderStreet !== undefined && data.row.senderStreet !== null ? (data.row.senderStreet + '/') : '' }}</span>
            <span>{{ `${data.row.senderDetailedAddress || ''} ` }}</span>
          </div>
        </template>
        <template slot="receiverName" slot-scope="data">
          <div v-if="countryId === 1 && data.row.receiverCountryName === 'KSA'" >
            <span>{{ `${data.row.receiverName}/` }}</span>
            <span v-mask="{data: {...data.row,apiType:2},  key: 'receiverMobilePhone', type: 'orderPlaintext' }" ></span>
            <span v-mask="{data: {...data.row,apiType:2},  key: 'receiverTelphone', type: 'orderPlaintext' }" >/</span>
            <span>{{ `/${data.row.receiverProvinceName}/` }}</span>
            <span>{{ `/${data.row.receiverCityName}` }}</span>
            <span>{{ data.row.receiverAreaName ? '/' + data.row.receiverAreaName : '' }}</span>
            <span>{{ data.row.receiverStreet !== null && data.row.receiverStreet !== null ? (data.row.receiverStreet + '/') : '' }}</span>
            <span>{{ `${data.row.receiverDetailedAddress || ''} ` }}</span>
          </div>
          <div v-else>
            <span>{{ `${data.row.receiverName}/` }}</span>
            <span v-mask="{data: {...data.row,apiType:2},  key: 'receiverMobilePhone', type: 'orderPlaintext' }" ></span>
            <span v-mask="{data: {...data.row,apiType:2},  key: 'receiverTelphone', type: 'orderPlaintext' }" >/</span>
            <span>{{ `/${data.row.receiverProvinceName}` }}</span>
            <span>{{ `/${data.row.receiverCityName}` }}</span>
            <span>{{ data.row.receiverStreet !== undefined && data.row.receiverStreet !== null ? (data.row.receiverStreet + '/') : '' }}</span>
            <span>{{ `${data.row.receiverDetailedAddress || ''} ` }}</span>
          </div>
        </template>
        <template slot="goodsDetail" slot-scope="scope">
          <el-button @click.stop="rowGoodsDetail(scope.row)" type="text">{{ $lang('查看') }}</el-button>
        </template>
        <template slot="menu" slot-scope="data">
          <div>
            <!-- 查看按钮 -->
            <el-button @click="rowView(data.row)" type="text">{{ $lang('查看') }}</el-button>
            <!-- <el-button v-if="data.row.isMasterAcc" @click="rowEdit(data.row)" type="text">{{ $lang('编辑') }}</el-button> -->
            <!-- 编辑按钮 -->
            <!-- <el-button v-show="data.row.orderStatusName=='待打印'||data.row.orderStatusName=='已打印'" @click="rowEdit(data.row)" type="text" icon="iconfont iconbianji font-16"></el-button> -->
            <!-- 取消按钮 -->
            <el-button v-if="data.row.orderStatusName == '待打印' || data.row.orderStatusName == '已打印'" @click="cancelFn(data.row)" type="text">{{ $lang('取消') }}</el-button>
            <!-- 删除按钮 -->
            <el-button v-if="data.row.orderStatusName == '已取消'"  @click="rowDel({ orderId: data.row.id })" type="text">{{ $lang('删除') }}</el-button>
          </div>
        </template>
      </JmsTableScroll>
    </div>

    <!-- 订单详情弹框组件 -->
    <bullet
      :fromType="fromType"
      @handleSubmit="handleSubmit"
      ref="bullet"
      :viewDialogVisible="viewDialogVisible"
      @closeDetails="closeDetails"
      :bulletTitle="1"
      :rowData="rowData"
    ></bullet>
    <!-- 取消订单弹框组件 -->
    <cancel-order :selectId="selectId" ref="cancelOrder" @cancelSuccess="cancelSuccess"></cancel-order>
    <!-- 导出订单弹框组件 -->
    <export-componet
      ref="exportComponet"
      :cityOptions="orderOptionsInter"
      :idsLength="multipleSelection.length"
      :exportVisible="exportVisible"
      :exportData="exportData"
      @export-close="exportClose"
      @export-fn="exportFn"
    ></export-componet>

    <!-- 下载中心 -->
    <ExportDownloadDialog :moduleType="moduleType" :dialogExportDownVisible.sync="dialogExportDownVisible"></ExportDownloadDialog>
    <item-detail ref="item-detail" sourceType="orderList"></item-detail>
  </div>
</template>
<script>

import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin.js'
import { orderrDelete, detailOrder, orderUpdate, UserDetail, orderBatchDelete } from '@/api/module/customer'
import bullet from './components/Detail.vue'
import cancelOrder from './components/CancelOrder.vue'
import exportComponet from '@components/base/BaseExport.vue'
import { commonFun } from '@utils/common'
import { orderOptionsInter, RESPONSE_SUCCESS, orderOptionsInterHDL } from '@constants'
import Print from '@components/jms-widget/print'
import { mapActions, mapState } from 'vuex'
import ExportDownloadDialog from '@components/export-download-dialog/ExportDownloadDialog.vue'
import ItemDetail from '../batch-entry/components/ItemDetail.vue'
import { orderListAPI } from './pool'

export default {
  name: 'Order',
  mixins: [mixin],
  components: {
    JmsTableScroll,
    bullet,
    cancelOrder,
    exportComponet,
    Print,
    ExportDownloadDialog,
    ItemDetail
  },
  data() {
    const that = this
    return {
      pickerOptions: {
        disabledDate(time) {
          const space = 90 * 24 * 3600 * 1000
          const minTime = new Date().getTime() - space
          const maxTime = that.$dayjs(new Date().getTime()).format('YYYY-MM-DD') + ' 23:59:59'
          return time.getTime() < minTime || time.getTime() > maxTime
        },
      },
      COM_HTTP: {
        reqList: this.$API_INTER.orderList,
        reqExcel: this.$API_INTER.asyExportOrder,
        reqDel: orderrDelete,
        reqDetail: detailOrder,
        reqUpdate: orderUpdate
      },
      isShowFirst: false,
      searchParam: {
        date: commonFun.GetTodayDate(),
        startdate: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        enddate: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        ids: [], // 订单号
        receiverMobilePhone: '', // 手机号
        tabTypeCode: 'wait_print', // 页签（all，wait_pick，already_pick，already_cancle）
        internationalOrderStatus: '',
        waybillIds: [],
        customerOrderIds: [],
        receiverCountryCode: '',
        senderCountryCode: '',
        serviceTypeCode: ''
        // serviceTypeCode: 'C01'
      },
      menuItems: [], // tab菜单
      activeIndex: '1', // tab 选中
      multipleSelection: [], // 多选或全选数据
      disabled: true, // 禁止点击状态
      exportVisible: false, // 导出弹框显示
      excelParams: {}, // 导出日期条件
      exportStatus: 'wait_print', // 默认状态
      exportType: 1, // 1：订单； 2：运单
      exportData: {},
      orderOptionsInter: [],
      selectId: '', // 当前选中的id
      printLoading: false, // 打印按钮loading
      exportLoading: false, // 导出loading
      printTableVisible: false, // 子订单打印
      isShowMerge: false, // 合并
      mergeList: [], // 合并数据
      printOptions: {
        btnTitle: this.$lang('面单打印'),
        btnType: 'primary',
        addClass: 'h40',
      },
      isCheckedAll: false,
      page: {
        // 分页配置
        current: 1,
        size: 100,
        total: 0,
        sizes: [
          50,
          100,
          200,
          500,
          1000,
        ],
      },
      tabActive: 1,
      isKeyUp: false,
      autoPrint: false,
      dialogExportDownVisible: false, // 下载中心
      moduleType: 'my_order_inter', // 我的订单
      isRowDetailUrl: true,
      fromType: '',
      isInter: false,
      serviceTypeList: [
        {
          label: this.$t('进口国际件'),
          value: 'C01'
        },
        {
          label: this.$t('出口国际件'),
          value: 'C03'
        }
      ],
      dhlLoading: false
    }
  },
  computed: {
    ...mapState({
      countryList: state => state.base.countryList
    }),
    listOpt() {
      return {
        border: true,
        selection: true,
        menu: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        // rowKey: '$index',
        fixHeight: 90,
        menuWidth: 150,
        // menuWidth: 150,
        //  搜索框和表格列及其字段
        column: [
          {
            label: this.$lang('订单编号'),
            prop: 'id',
          },
          {
            label: this.$lang('运单编号'),
            prop: 'waybillId',
            slot: true,
            width: 150,
          },
          {
            label: this.$lang('状态'),
            prop: 'orderStatusName',
            slot: true,
          },
          {
            label: '操作状态',
            prop: 'internationalOrderStatus'
          },
          {
            label: this.$lang('打印次数'),
            prop: 'printsNumber',
          },
          {
            label: '服务类型',
            prop: 'serviceTypeName'
          },
          {
            label: this.$lang('客户订单号'),
            prop: 'customerOrderId',
            width: 150,
          },
          {
            label: '寄件人国家',
            prop: 'senderCountryName'
          },
          {
            label: '寄件人区号',
            prop: 'senderPhoneAreacode'
          },
          {
            label: this.$lang('寄件人地址'),
            prop: 'senderName',
            slot: true,
            // formatter: (row, value, label, column) => {
            //   if (this.countryId === 1 && row.senderCountryName === 'KSA') {
            //     return `${row.senderName}/${row.senderMobilePhone}/${row.senderProvinceName}/${row.senderCityName}${row.senderAreaName ? '/' + row.senderAreaName : ''}/${row.senderStreet !== undefined && row.senderStreet !== null ? (row.senderStreet + '/') : ''}${row.senderDetailedAddress}`
            //   } else {
            //     return `${row.senderName}/${row.senderMobilePhone}/${row.senderProvinceName}/${row.senderCityName}/${row.senderStreet !== undefined && row.senderStreet !== null ? (row.senderStreet + '/') : ''}${row.senderDetailedAddress}`
            //   }
            // },
            width: 400,
          },
          {
            label: '收件人国家',
            prop: 'receiverCountryName'
          },
          {
            label: '收件人区号',
            prop: 'receiverPhoneAreacode'
          },
          {
            label: '收件人证件号',
            prop: 'receiverIdNumber'
          },
          {
            label: this.$lang('收件方'),
            prop: 'receiverName',
            slot: true,
            // formatter: (row, value, label, column) => {
            //   if (this.countryId === 1 && row.receiverCountryName === 'KSA') {
            //     return `${row.receiverName}/${row.receiverMobilePhone}${row.receiverTelphone ? '/' + row.receiverTelphone : ''}/${row.receiverProvinceName}/${row.receiverCityName}${row.receiverAreaName ? '/' + row.receiverAreaName : ''}/${row.receiverStreet !== undefined && row.receiverStreet !== null ? (row.receiverStreet + '/') : ''}${row.receiverDetailedAddress}`
            //   } else {
            //     return `${row.receiverName}/${row.receiverMobilePhone}${row.receiverTelphone ? '/' + row.receiverTelphone : ''}/${row.receiverProvinceName}/${row.receiverCityName}/${row.receiverStreet !== undefined && row.receiverStreet !== null ? (row.receiverStreet + '/') : ''}${row.receiverDetailedAddress}`
            //   }
            // },
            width: 400,
          },
          {
            label: '物品明细',
            prop: 'goodsDetail',
            slot: true,
            width: 150,
          },
          {
            label: this.$lang('物品重量'),
            prop: 'packageTotalWeight',
          },
          {
            label: this.$lang('长(cm)'),
            prop: 'packageLength',
          },
          {
            label: this.$lang('宽(cm)'),
            prop: 'packageWide',
          },
          {
            label: this.$lang('高(cm)'),
            prop: 'packageHigh',
          },
          {
            label: '产品类型',
            prop: 'expressTypeName',
            formatter({ expressTypeName, expressTypeCode }) {
              return (expressTypeName || '--') + ' | ' + (expressTypeCode || '--')
            },
          },
          {
            label: '物品类型',
            prop: 'goodsTypeName',
          },
          {
            label: this.$lang('代收货款金额'),
            prop: 'codMoney',
            formatter({ codMoney, codCurrencyTypeName }) {
              if (codMoney) {
                return `${codMoney} ${codCurrencyTypeName || ''}`
              } else {
                return '--'
              }
            },
          },
          {
            label: this.$lang('代收货款币别'),
            prop: 'codCurrencyTypeName',
            width: 110,
          },
          {
            label: this.$lang('备注'),
            prop: 'remarks',
            width: 200,
          }
        ],
      }
    },
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    countryId() {
      return this.$store.state.base.user.countryId || ''
    },
    printDisabled() {
      // 211130,不论是否调度都能打印
      const { multipleSelection } = this
      // const hasDi = multipleSelection.some(item => item.needDispatch === 1)
      // return hasDi || !multipleSelection.length
      return !multipleSelection.length
    },
    dhlDisabled() {
      return this.multipleSelection.length <= 0 || this.multipleSelection.some(i => i.serviceTypeCode !== 'C03')
    }
  },
  watch: {
    tableList: {
      handler(newVal, oldVal) {
        if (this.isKeyUp && this.exportStatus === 'wait_print' && this.tableList.length === 1 && this.autoPrint) {
          this.autoPrint = false
          this.multipleSelection = this.tableList
          this.$nextTick(() => {
            this.$refs.table.$refs.table.toggleRowSelection(this.tableList[0], true)
            this.$refs.printOrder && this.$refs.printOrder.openMenu()
          })
        }
      },
    },
    deep: true,
  },
  async created() {
    this.isSinleSelection = []
    this.getUserInfo()
    const key = this.$route.params.typeNum
    this.updateOutExcel(key)
    await this.orderTotalGroup(this.searchParam)
    if (key) {
      this.handleSelect(key)
    } else {
      this.searchFun()
    }
  },
  mounted() {
    this.GETCOUNTRY()
  },
  methods: {
    ...mapActions([
      'LOGIN_OUT',
      'SET_USER',
      'UPDATE_PRINT_STOCK',
      'GETCOUNTRY'
    ]),
    rowGoodsDetail(row) {
      this.$refs['item-detail'].showDialog(0, row.items || [])
    },
    async rowEdit(row) {
      this.fromType = 'editRouter'
      // 获取查看详情
      await this.viewFun(row)
      this.viewDialogVisible = true
    },
    /**
     * @description 复制
     */
    handleCopy(data) {
      const value = data.row.waybillId
      const oInput = document.createElement('input')
      oInput.value = value
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: this.$lang('运单号复制成功'),
        type: 'success',
      })
      oInput.remove()
    },
    // 选择分页条数
    sizeChange(val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },

    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
      this.multipleSelection = []
      this.isCheckedAll = false
    },
    toKeyUp() {
      if (this.isKeyUp) { // 回车搜索后首次输入清空输入框
        this.searchParam.customerOrderIds = []
        this.isKeyUp = false
      }
      return true
    },
    async payCode(e) {
      this.isKeyUp = true
      this.autoPrint = true
      this.searchFun(1)
      this.orderTotalGroup(this.searchParam)
    },
    // 获取打印数据
    async getPrintData(type, language) {
      const obj = this.multipleSelection.find(item => item.paymentModeName === '到付现结' && (!item.standardValue || item.standardValue === 0 || item.standardValue === '0'))
      if (obj) {
        this.$nextTick(() => {
          this.$message.warning(this.$lang('存在到付快件未维护费用，请联系网点维护'))
          this.multipleSelection = []
          this.isCheckedAll = false
          this.searchChange()
        })
        this.$refs['printOrder'].keyBtn = false
        return false
      }
      const newArr = this.multipleSelection.map((item, index, selection) => item.id)
      const params = { ids: newArr, printType: type, isVip: true, language } // 添加language
      const res = await this.$API_INTER.printOrders(params)
      console.log(res)
      if (res.code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
        // settlementName 到付现结 freight
        this.isCheckedAll = false
        setTimeout(() => {
          this.searchChange()
          // 更新库存面单
          if (this.exportStatus !== 'already_print') {
            this.UPDATE_PRINT_STOCK(true)
          }
        }, 1100)
        return res.data
      } else {
        this.$refs['printOrder'].keyBtn = false
        res.msg && this.$message.error(this.$lang(res.msg))
        return false
      }
    },
    // 更新面单库存(获取用户信息)
    async getUserInfo() {
      const { code, data, msg } = await UserDetail({ id: this.userInfo.id })
      if (code === RESPONSE_SUCCESS) {
        this.SET_USER({ ...this.userInfo, ...data }) // 更新vuex的用户数据
      } else {
        this.$message.error(msg)
      }
    },
    // 删除订单
    async batchDelOrder() {
      const ids = []
      this.multipleSelection.forEach(item => {
        if (item.orderStatusName === '已取消') {
          ids.push(item.id)
        }
      })
      if (ids.length <= 0) {
        this.$message.warning(this.$lang('没有可取消的订单'))
        return
      }
      this.$confirm(
        `
      <div class="comfirm-wrap">
        <i class="el-icon-warning"></i>
        <h3 class="comfirm-hd">${this.$lang('删除订单')}</h3>
      </div>
      <p class="comfirm-tit">${this.$lang('你确定要删除已选中的订单吗？')}</p>
      `,
        '',
        {
          confirmButtonText: this.$lang('确定'),
          cancelButtonText: this.$lang('取消'),
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          customClass: 'comfirm-box',
        }
      )
        .then(async () => {
          this.loading = true
          const { code, msg } = await orderBatchDelete(ids)
          this.loading = false
          if (code === RESPONSE_SUCCESS) {
            this.$message.success(this.$lang('删除成功'))
            this.searchChange()
          } else {
            this.$message.error(this.$lang(msg))
          }
        })
        .catch(_ => {
        })
    },
    // 取消订单
    batchCancelOrder() {
      const ids = []
      this.multipleSelection.forEach(item => {
        if (item.orderStatusName === '待打印' || item.orderStatusName === '已打印') {
          ids.push(item.id)
        }
      })
      if (ids.length <= 0) {
        this.$message.warning(this.$lang('没有可取消的订单'))
        return
      }
      this.selectId = ids.join(',')
      this.$refs.cancelOrder.dialogTableVisible = true
    },
    // 面单打印
    openMenu(e, sub) {
      this.$rightMenu.open({
        target: e,
        menuList: [
          {
            val: this.$lang('两联面单'),
            abled: true,
            value: 2,
          },
          {
            val: this.$lang('一联面单'),
            abled: true,
            value: 1,
          },
        ],
        posobj: {
          left: e.clientX,
          top: e.clientY,
        },
        callback: ({ value }) => {
          this.print(value)
          this.$rightMenu.close()
        },
      })
    },
    // 选择日期
    selectDate() {
      if (!this.searchParam.date) {
        return
      }
      const [start = '', end = ''] = this.searchParam.date
      this.searchParam.startdate = start
      this.searchParam.enddate = end
    },
    // 查询
    async searchChange(params) {
      const { startdate, enddate } = this.searchParam
      const space = 31 * 24 * 3600 * 1000
      const startTime = new Date(startdate).getTime()
      const endTime = new Date(enddate).getTime()
      if ((endTime - startTime) > space) {
        this.$message.error(this.$lang('开始时间与结束时间之差不能大于31天'))
        return
      }
      this.searchParam.tabTypeCode = this.menuItems.length > 0 ? this.menuItems[this.activeIndex].orderStatusCode : ''
      this.searchParam.internationalOrderStatus = this.menuItems.length > 0 ? this.menuItems[this.activeIndex].orderStatusCode : ''
      // 处理订单编号
      const { ids, waybillIds } = this.searchParam
      if (ids && ids.length !== 0) {
        if (ids.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条订单'))
        }
        const p_billNo = ids.join(',')
        if (isNaN(p_billNo.replace(/,/g, ''))) {
          return this.$message.error(this.$lang('订单编号为全数字'))
        }
      }
      this.searchParam.customerOrderIds = this.searchParam.customerOrderIds.length > 0 && !this.searchParam.customerOrderIds[0] ? [] : this.searchParam.customerOrderIds
      // 处理运单编号
      if (waybillIds && waybillIds.length !== 0) {
        if (waybillIds.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条运单'))
        }
      }
      // 列表查询
      this.searchFun(1)
      // 列表总数查询
      this.orderTotalGroup(this.searchParam)
      this.multipleSelection = []
    },
    getParams() {
      const { tabTypeCode, ids, internationalOrderStatus } = this.searchParam
      const newIds = ids && ids.length >= 1 && ids[0] === '' ? [] : ids
      const searchParam = Object.assign({}, this.searchParam)
      searchParam.ids = newIds
      console.log(this.isInter, '国际件----------------?>')
      if (this.isInter) {
        searchParam.internationalOrderStatus === '0' ? '' : internationalOrderStatus
        searchParam.tabTypeCode = ''
      } else {
        searchParam.internationalOrderStatus = ''
        searchParam.tabTypeCode === '0' ? '' : tabTypeCode
      }
      searchParam.isVip = true
      console.log(searchParam)
      const arr = ['current', 'size', 'startdate', 'enddate', 'date', 'internationalOrderStatus', 'tabTypeCode', 'columnNames', 'sort', 'orderStatusCode', 'isVip', 'serviceTypeCode']
      Object.keys(searchParam).forEach(item => {
        if (!arr.includes(item)) {
          if (searchParam[item] instanceof Array && searchParam[item][0]) {
            delete searchParam.startdate
            delete searchParam.enddate
          } else if (typeof searchParam[item] === 'string' && searchParam[item]) {
            delete searchParam.startdate
            delete searchParam.enddate
          }
        }
      })
      return searchParam
    },
    handleSelect(key) {
      const menuItems = this.menuItems
      this.searchParam.tabTypeCode = menuItems[key].orderStatusCode
      this.searchParam.internationalOrderStatus = menuItems[key].orderStatusCode
      this.isInter = !!menuItems[key].inter
      this.exportStatus = menuItems[key].orderStatusCode
      this.activeIndex = key
      this.currentKey = parseInt(key)
      this.page.current = 1
      this.isCheckedAll = false
      // 重置表格滚动条置顶
      this.$refs.table.$el.querySelector('.el-table__body-wrapper').scrollTop = 0
      this.searchFun()
      // 清空选中数据
      this.multipleSelection = []
      this.autoPrint = false
      // 列表总数查询
      this.orderTotalGroup(this.searchParam)
      this.$nextTick(() => {
        this.$refs.table.$refs.table.doLayout()
      })
    },
    cancelFn(row) {
      this.selectId = row.id
      this.$refs.cancelOrder.dialogTableVisible = true
    },
    // 取消成功
    cancelSuccess() {
      this.multipleSelection = []
      this.isCheckedAll = false
      setTimeout(() => {
        this.orderTotalGroup(this.searchParam)
        this.searchFun()
      }, 1000)
    },
    // 打开导出弹框
    async exportOpen() {
      // 处理订单编号
      const { ids, waybillIds } = this.searchParam
      if (ids && ids.length !== 0) {
        if (ids.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条订单'))
        }
        const p_billNo = ids.join(',')
        if (isNaN(p_billNo.replace(/,/g, ''))) {
          return this.$message.error(this.$lang('订单编号为全数字'))
        }
      }
      // 处理运单编号
      if (waybillIds && waybillIds.length !== 0) {
        if (waybillIds.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条运单'))
        }
      }

      if (this.multipleSelection.length <= 0) {
        this.exportLoading = true
        await this.orderTotalGroup(this.searchParam)
        this.searchFun()
        this.exportLoading = false
        const listTotal = this.menuItems[this.activeIndex].total || 0
        if (listTotal <= 0) {
          this.$message.warning(this.$lang('没有可导出的数据'))
          return
        }
        if (listTotal > 100000) {
          this.$message.warning(this.$lang('导出数量超过限制'))
          return
        }
      }
      this.orderOptionsInter = [...orderOptionsInter]
      if (this.countryId === 1) {
        const receiverAreaName = {
          key: 'receiverAreaName',
          name: '收件区域'
        }
        const senderAreaName = {
          key: 'senderAreaName',
          name: '寄件区域'
        }
        this.orderOptionsInter.push(receiverAreaName, senderAreaName)
      }
      /**
       * @description 如果设置了 不显示参考运费 删除参考运费
       */
      if (this.userInfo.freightStatus === 0) {
        const chooseIndex = this.orderOptionsInter.findIndex(item => item.name === '参考运费')
        // 删除参考运费选项
        this.orderOptionsInter.splice(chooseIndex, 1)
      }

      this.updateOutExcel(this.currentKey)
      this.exportVisible = true
      const exportData = {
        // startDate: this.searchParam.startdate,
        // endDate: this.searchParam.enddate,
        exportStatus: this.exportStatus,
        exportType: this.exportType, // 1：订单； 2：运单
      }
      this.exportData = exportData
    },
    // 关闭导出弹框
    exportClose(val) {
      this.exportVisible = val
    },
    // 导出-获取参数
    getParamForOutExcel() {
      const sort = []
      const columnNames = []
      let ids = []
      const len = this.multipleSelection && this.multipleSelection.length || 0
      if (len) ids = this.multipleSelection.map(item => item.id)
      // 处理导出表格的属性字段
      this.columnList.forEach(item => {
        sort.push(item.key)
        columnNames.push(item.name)
      })
      let params = { sort, columnNames, orderStatusCode: this.exportStatus, isVip: true }
      if (len) params = { ...params, ids }
      else {
        params = { ...params, ...this.searchParam }
      }
      const arr = ['current', 'size', 'startdate', 'enddate', 'date', 'tabTypeCode', 'columnNames', 'sort', 'orderStatusCode', 'internationalOrderStatus', 'isVip', 'serviceTypeCode']
      Object.keys(params).forEach(item => {
        if (!arr.includes(item)) {
          if (params[item] instanceof Array && params[item][0]) {
            delete params.startdate
            delete params.enddate
          } else if (typeof params[item] === 'string' && params[item]) {
            delete params.startdate
            delete params.enddate
          }
        }
      })
      if (this.isInter) {
        params.tabTypeCode = ''
        params.internationalOrderStatus = this.exportStatus
      } else {
        params.tabTypeCode = this.exportStatus
        params.internationalOrderStatus = ''
      }
      return params
    },
    // 导出数据
    async exportFn(bool, data, dataParams) {
      this.exportVisible = bool
      this.columnList = data
      this.excelParams = dataParams
      //   await this.outExcel()
      //   改为异步导出
      await this.asyExportOrder()
    },
    async asyExportOrder() {
      const param = this.getParamForOutExcel()
      // 调用导出api
      const { code, msg } = await this.COM_HTTP.reqExcel(param)
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('导出成功，请到下载中心查看'))
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 更新导出参数配置
    updateOutExcel(key = 0) {
      // cityOptions
      const inputTime = {
        key: 'inputTime',
        name: this.$lang('下单时间'),
      }
      const pickTime = {
        key: 'pickTime',
        name: this.$lang('取件时间'),
      }
      const cancelTime = {
        key: 'cancelTime',
        name: this.$lang('取消时间'),
      }
      //   const printTime = {
      // key: 'printTime',
      // name: '打印时间',
      //   }
      this.orderOptionsInter.push(inputTime, pickTime, cancelTime)
    },
    // 获取tabs
    async orderTotalGroup(reqData) { // 运单状态数据统计
      const { code, data } = await this.$API_INTER.orderTotalGroup(this.getParams())
      if (code === RESPONSE_SUCCESS) {
        console.log(data)
        const { internationalOrderStatusGroupVO, orderStatusGroupVO } = data
        internationalOrderStatusGroupVO.forEach(item => {
          item.orderStatusCode = item.internationalOrderStatusCode
          item.orderStatusName = item.internationalOrderStatusCode
          item.inter = true
        })
        this.menuItems = [...orderStatusGroupVO, ...internationalOrderStatusGroupVO]
      }
    },
    // 查看
    rowView(row) {
      this.fromType = ''
      this.selectId = row.id
      this.viewDialogVisible = true
      this.rowData = row
      // 获取查看详情
      this.viewFun(row)
    },
    // close:关闭；delWaybill删除运单  ； cancelOrder:取消订单； ediOrder:编辑订单 delOrder:删除订单；
    closeDetails(val) {
      this.viewDialogVisible = val.viewDialogVisible
      switch (val.type) {
        case 'cancelOrder':
          this.$refs.cancelOrder.dialogTableVisible = true
          break
        case 'ediOrder':
          this.editDialogVisible = true
          break
        case 'delOrder':
          const item = {
            orderId: val.rowData.id,
          }
          this.rowDel(item)
          break
      }
    },
    resetSearch() {
      this.searchParam = {
        ids: [],
        date: commonFun.GetTodayDate(),
        startdate: commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        enddate: commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        waybillIds: [],
        customerOrderIds: [],
      }
      this.$refs.BaseInputTag1.clearFn()
      this.$refs.BaseInputTag2.clearFn()
    },
    // 全选
    handleSelectAll1(val) {
      this.multipleSelection = val
      this.originSelectionAll = [...val]
      if (val.length) {
        this.isCheckedAll = true
      } else {
        this.isCheckedAll = false
      }
    },
    // 单个选中
    handleSelectionChange(val, currentRow) {
      // 检测当前行的选中状态
      const isChecked = val.some(item => item.id === currentRow.id)
      if (this.isCheckedAll) {
        if (!isChecked) {
          this.isSinleSelection = [...(this.isSinleSelection || []), currentRow.id]
        } else {
          this.isSinleSelection = this.isSinleSelection.filter(item => item !== currentRow.id)
        }
        this.multipleSelection = this.originSelectionAll.filter(item => !this.isSinleSelection.includes(item.id))
      } else {
        this.multipleSelection = val
      }
    },
    changeTab(index) {
      this.tabActive = index
      this.handleSelect(index)
    },
    /**
     * 去快件查询
     */
    getExpressTracking(waybillId) {
      this.$router.push({ path: '/expressTracking', query: { waybillId }})
    },
    async handleSubmit(updateParams) {
      await this.$refs.bullet.$refs.bulletEdit.$refs.sizeForm.validate()
      console.log('检验通过updateParams', updateParams)
      const res = await this.COM_HTTP['reqUpdate'](updateParams)
      if (res.code !== RESPONSE_SUCCESS) {
        this.$message.warning(res.msg)
        return
      }
      this.viewDialogVisible = false
      this.$refs.bullet.$refs.bulletEdit.$refs.sizeForm.resetFields()
      setTimeout(() => {
        this.searchFun()
      }, 300)
      this.$message.success(this.$lang('保存成功'))
    },
    async DhlOutput() {
      const { ids, waybillIds } = this.searchParam
      if (ids && ids.length !== 0) {
        if (ids.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条订单'))
        }
        const p_billNo = ids.join(',')
        if (isNaN(p_billNo.replace(/,/g, ''))) {
          return this.$message.error(this.$lang('订单编号为全数字'))
        }
      }
      if (waybillIds && waybillIds.length !== 0) {
        if (waybillIds.length > 100) {
          return this.$message.warning(this.$lang('请勿超过100条运单'))
        }
      }

      if (this.multipleSelection.length <= 0) {
        this.dhlLoading = true
        await this.orderTotalGroup(this.searchParam)
        this.searchFun()
        this.dhlLoading = false
        const listTotal = this.menuItems[this.activeIndex].total || 0
        if (listTotal <= 0) {
          this.$message.warning(this.$lang('没有可导出的数据'))
          return
        }
        if (listTotal > 100000) {
          this.$message.warning(this.$lang('导出数量超过限制'))
          return
        }
      }
      const params = {
        ...this.searchParam,
        columnNames: orderOptionsInterHDL.map(i => i.name),
        sort: orderOptionsInterHDL.map(j => j.key),
        orderStatusCode: 'wait_print',
        isVip: true
      }
      this.dhlLoading = false
      const { code, msg } = await orderListAPI.reqDHLExport(params)
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('任务创建成功!请去下载中心下载！'))
      } else {
        this.$message.error(this.$lang(msg))
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}

.el-menu-item {
  height: 32px;
  line-height: 32px;
  padding: 0 3px;
  margin: 0 20px;
  text-align: center;
}

.el-menu-item:first-of-type {
  padding-left: 0;
  margin-left: 0;
  text-align: left;
}

input {
  font-size: 12px !important;
}

.order {
  .order-top {
    padding: 16px 24px;

    .commonSize {
      width: 328px !important;
      height: 32px !important;
    }
  }

  .order-bottom {
    padding: 12px 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #edeef3;
    box-sizing: border-box;
  }

  .search-btns {
    margin-bottom: 10px;
  }

  .tabs-nav {
    // margin: 5px 0 9px;
    .tabs-nav-item {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 20px;
      font-size: 16px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      margin-left: 10px;

      &:first-of-type {
        margin-left: 0px;
      }

      i {
        margin-right: 8px;
        color: #666;
      }

      &.active {
        background: #fff;
        color: #e60012;

        i {
          color: #e60012;
        }
      }
    }

    .tabs-nav-item-count {
      display: inline-block;
      width: 35px;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      background: rgba(102, 102, 102, 0.1);
      border-radius: 10px;
      margin-left: 5px;
    }
  }
}
</style>
<style lang="scss">
.order .order-top .el-input__inner {
  margin-bottom: 10px;
}
</style>
